import React, { useEffect, useRef } from 'react';
import { clients } from '../mockData';

const Clients = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval;
    let animationFrameId;
    
    const startScrolling = () => {
      const scroll = () => {
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0;
        } else {
          scrollContainer.scrollLeft += 1;
        }
        animationFrameId = requestAnimationFrame(scroll);
      };
      
      // Start scrolling after a brief delay to ensure content is loaded
      setTimeout(() => {
        animationFrameId = requestAnimationFrame(scroll);
      }, 1000);
    };

    // Start auto-scroll immediately
    startScrolling();

    // Pause on hover
    const handleMouseEnter = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
    const handleMouseLeave = () => startScrolling();

    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      clearInterval(scrollInterval);
      scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
      scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  // Triple clients array for smoother seamless loop
  const duplicatedClients = [...clients, ...clients, ...clients];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-red-600">Clients</span>
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6" />
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Trusted by leading organizations in the oil & gas industry worldwide
          </p>
        </div>

        {/* Auto-Scrolling Clients Carousel */}
        <div className="relative overflow-hidden">
          <div
            ref={scrollRef}
            className="flex gap-8 overflow-x-hidden"
            style={{ scrollBehavior: 'auto' }}
          >
            {duplicatedClients.map((client, index) => (
              <div
                key={`${client.id}-${index}`}
                className="flex-shrink-0 bg-white rounded-xl shadow-lg p-8 w-64 h-40 flex items-center justify-center hover:shadow-xl transition-all duration-300"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-24 max-w-full w-auto object-contain transition-all duration-300"
                  onError={(e) => {
                    // If image fails to load, show company name instead
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<div class="text-slate-600 font-semibold text-center">${client.name}</div>`;
                  }}
                  loading="eager"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;